// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Wrapper_wrapper__hiVVD","edgeToEdge":"Wrapper_edgeToEdge__mxaSI"};